// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"698557c9","473":"668df11b","488":"90e2fe10"}[chunkId] + ".chunk.js";
};